import {
  Component,
  Input,
  forwardRef,
  ElementRef,
  Renderer
} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

/*##################################################################################*
 * COMPOSANT SPRO : spro-radio
 *
 * DESCRIPTION : Composant permettant l'affichage de boutons radio
 *
 ##################################################################################*/

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => spro_cls_radio),
  multi: true
};

@Component({
  selector: "spro-radio",
  styleUrls: ["./spro-radio.component.scss"],
  template: `
    <ul>
      <li *ngFor="let item of h_data" class="spro-radio-li">
        <input
          type="radio"
          [value]="item.value"
          [disabled]="!f_actif"
          (click)="proc_onChange($event)"
        />
        <label>{{ item.title | translate }}</label>
      </li>
    </ul>
  `,
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class spro_cls_radio implements ControlValueAccessor {
  /** Liste des radio du composant */
  @Input() h_data: any;
  /** Pour désactiver la radio */
  @Input() f_actif: boolean = true;

  /**
   *
   */
  public proc_onChange: (value: any) => void;

  validateFn: any = () => {};

  /*##############################################################################
    ###################   Necessaire a la gestion du ng Model ####################
    ##############################################################################*/

  constructor(public _renderer: Renderer, public _elementRef: ElementRef) {
    this.proc_onChange = function fds(e: any) {
      console.log("fs", e.path[0].attributes[2].nodeValue);
    };
  }

  /**
   *
   */
  writeValue(value: any): void {
    this._renderer.setElementProperty(
      this._elementRef,
      "checked",
      value === this._elementRef.nativeElement.value
    );
  }

  /**
   *
   */
  registerOnChange(fn: (value: any) => void) {
    this.proc_onChange = fn;
  }

  /**
   *
   */
  registerOnTouched() {}
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/inputs/spro-radio/spro-radio.component.ts